export const isHtml = value => {
  if (typeof value !== 'string') {
    return false;
  }

  return /<\/?[a-z][\s\S]*>/i.test(value.trim());
};
